import React, { useEffect, useState } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  useNotify,
  useRedirect,
  BooleanInput,
  required,
} from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { Skeleton } from '@mui/material'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const ModuleCreate = (props) => {
  const notify = useNotify()
  const redirect = useRedirect()
  const translate = useTranslate()
  const [application, setApplication] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      try {
        const allApplications = await applicationServices.getByAll()
        if (allApplications) {
          setApplication(allApplications)
          setLoading(false)
          return
        }
        notify(`applications not found`, { type: 'error' })
        setLoading(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoading(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.module') }
    })
    redirect('/module')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.module') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_module')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput label='' source='short_name' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')}>
              <TextInput label='' source='long_name' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loading ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={application}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.is_active')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
